import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ApiService } from '../../../services/api.service';
import { MODAL_CONFIG } from '../../../services/constant';
import { DepartmentListComponent } from '../department-list/department-list.component';
import { Department } from '../department.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'department-list-detail',
  templateUrl: './department-list-detail.component.html',
  styleUrls: ['./department-list-detail.component.scss']
})
export class DepartmentListDetailComponent implements OnInit {
  modalRef: BsModalRef;
  title = '';
  createMode = false;
  errorMessage: string = null;
  parent: DepartmentListComponent = null;
  departmentForm: FormGroup;
  selectedDepartment: Department;

  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private translate: TranslateService,
  ) {}

  open(parent: DepartmentListComponent, selectedDepartment?: Department) {
    this.parent = parent;
    this.errorMessage = null;

    if (selectedDepartment) {
      this.selectedDepartment = selectedDepartment;
      this.departmentForm.patchValue({
        code: selectedDepartment.code,
        nameEng: selectedDepartment.name_en,
        nameThai: selectedDepartment.name_th,
        abbreviation: selectedDepartment.abbreviation,
        abbCode: selectedDepartment.abb_code,
      });
      this.title = this.translate.instant('DEPARTMENT.LIST.MODAL.TITLE') + ' : ' + selectedDepartment.code;
    } else {
      this.title = this.translate.instant('DEPARTMENT.LIST.MODAL.ADD-DEPARTMENT');
    }

    this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
  }

  ngOnInit() {
    this.departmentForm = this.formBuilder.group({
      code: ['', Validators.required],
      nameEng: ['', Validators.required],
      nameThai: ['', Validators.required],
      abbreviation: ['', Validators.required],
      abbCode: [],
    })
  }

  preparedErrorMessage() {
    const errorFields = [];
    if (this.translate.currentLang === 'en') {
      if (this.departmentForm.controls.code.errors) {
        errorFields.push('Department ID');
      }
      if (this.departmentForm.controls.nameEng.errors) {
        errorFields.push('Department Name(EN)');
      }
      if (this.departmentForm.controls.nameThai.errors) {
        errorFields.push('Department Name(TH)');
      }
      if (this.departmentForm.controls.abbreviation.errors) {
        errorFields.push('Department Abbreviation');
      }
      this.errorMessage = 'Please fill ' + errorFields.join(', ') + ' correctly';
    } else {
      if (this.departmentForm.controls.code.errors) {
        errorFields.push('รหัสแผนก');
      }
      if (this.departmentForm.controls.nameEng.errors) {
        errorFields.push('ชื่อแผนก(ภาษาอังกฤษ)');
      }
      if (this.departmentForm.controls.nameThai.errors) {
        errorFields.push('ชื่อแผนก(ภาษาไทย)');
      }
      if (this.departmentForm.controls.abbreviation.errors) {
        errorFields.push("ตัวอักษรย่อ");
      }
      this.errorMessage = 'โปรดกรอก ' + errorFields.join(', ') + ' ให้ถูกต้อง';
    }
  }

  submit() {
    if (this.departmentForm.invalid) {
      this.preparedErrorMessage();
      return;
    }

    const payload = {
      code: this.departmentForm.value.code,
      name_en: this.departmentForm.value.nameEng,
      name_th: this.departmentForm.value.nameThai,
      abbreviation: this.departmentForm.value.abbreviation,
      abb_code: this.departmentForm.value.abbCode,
    };

    const request$ = this.selectedDepartment
      ? this.apiService.updateDepartment(this.selectedDepartment.id, payload)
      : this.apiService.createDepartment(payload);

    request$.subscribe(
      () => {
        this.parent.reload();
        this.modalRef.hide();
        this.clearData();
      },
      (error) => {
        this.checkErrorMsg(error);
      }
    );
  }

  checkErrorMsg(error) {
    this.errorMessage = this.apiService.getErrorMessageDepartment(error);
  }

  clearData() {
    this.departmentForm.reset();
    this.selectedDepartment = undefined;
    this.errorMessage = null;
  }

  close() {
    this.modalRef.hide();
    this.clearData();
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_DEPARTMENT',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      () => {},
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-list-detail/department-list-detail.component.ts